import axios from '@/http/axios/axios'

export default {
  namespaced: true,
  actions: {
    // ✅ Добавлены значения по умолчанию, чтобы не падало при вызове без параметров
    GET_LIST(state, payload = { page: 1, limit: 10 }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`program/notification/?page=${payload.page}&page_size=${payload.limit}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    GET_DATA(store, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`program/notification/${payload}/`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    POST_DATA(store, payload) {
      return new Promise((resolve, reject) => {
        // ⚠️ Если бэк вернёт 404, замените на 'dictionary/notification/'
        axios.post('program/notification/', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    PATCH_DATA(store, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(`program/notification/${payload.id}/`, payload.data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    DELETE_DATA(store, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(`program/notification/${payload}/`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    
    GET_SELECT() {
  return new Promise((resolve, reject) => {
    axios
      // ✅ Используем основной публичный список вместо закрытого select/
      .get('dictionary/program/?page_size=100')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
},
    GET_STAT() {
      return new Promise((resolve, reject) => {
        axios.get('stat/program/')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}